import React from 'react';
import { Typography, Box, Checkbox } from '@mui/material';
import MySQLFields from './MySQLFields';
import DataRequirementDocumentChip from '../../DataRequirementDocumentChip';
interface MySQLDetailsProps {
  loading: boolean;
  formValues: Record<string, string | string[]>;
  handleInputChange: (name: string, value: string | string[]) => void;
  setIsFormValid: (isValid: boolean) => void;
}

const MySQLDetails: React.FC<MySQLDetailsProps> = ({
  loading,
  formValues,
  handleInputChange,
  setIsFormValid,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: '4rem',
        width: '100%',
      }}
    >
      <Box
        sx={{
          flex: 1,
          py: '1rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem',
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: '1rem',
            lineHeight: '1.375rem',
            color: '#162936',
          }}
        >
          Please provide credentials to your MySQL database containing IAP, IAA, and UA spend
          tables.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1.25rem',
          }}
        >
          <MySQLFields
            isEditable={true}
            formValues={formValues}
            handleInputChange={handleInputChange}
            onValidityChange={setIsFormValid}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '0.25rem',
              alignItems: 'center',
            }}
          >
            <Checkbox
              checked={true}
              onChange={() => {}}
              sx={{
                color: '#7FBCAD',
              }}
            />
            <Typography
              fontSize="0.875rem"
              lineHeight="1.25rem"
              fontWeight={700}
              color="#162936"
              letterSpacing="-0.35px"
            >
              I authorise PvX to securely refresh my data each month for accurate reporting.
            </Typography>
          </Box>
          <ul
            style={{
              paddingLeft: '2rem',
              margin: 0,
              fontSize: '0.875rem',
              lineHeight: '1.25rem',
              fontWeight: 500,
              color: '#6C6C6C',
            }}
          >
            <li>
              Refresh the data tables by 5th of every month with the latest data to continue
              accessing Benchmarks and Financial Projections.
            </li>
            <li>Dashboards will be refreshed monthly by the 10th of each month.</li>
            <li>You can turn this off any time from ‘Settings’.</li>
          </ul>
        </Box>
      </Box>
      <Box
        sx={{
          flex: 1,
          borderRadius: '0.5rem',
          background: '#F0F0F1',
          padding: '1rem',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem',
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: '1.5rem',
            lineHeight: '1.875rem',
            color: '#6C6C6C',
          }}
        >
          Note the following for hassle free integration
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '1rem',
              lineHeight: '1.25rem',
              color: '#6C6C6C',
            }}
          >
            Download the Data Requirement document.
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '1rem',
              lineHeight: '1.25rem',
              color: '#6C6C6C',
            }}
          >
            This document details the data requirement, format and sharing mechanism.
          </Typography>
          <DataRequirementDocumentChip
            sx={{
              backgroundColor: '#FFFFFF',
              border: '1px solid #2F736E1F',
            }}
          />
        </Box>
        <Box>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '1rem',
              lineHeight: '1.25rem',
              color: '#162936',
              marginBottom: '0.75rem',
            }}
          >
            Ensure:
          </Typography>
          <ul
            style={{
              paddingLeft: '2rem',
              margin: 0,
              fontSize: '0.875rem',
              lineHeight: '1.25rem',
              fontWeight: 500,
              color: '#6C6C6C',
            }}
          >
            <li>Tables must follow the schema defined in Data Requirement Document.</li>
            <li>Columns like user_id, transaction_date, and gross/net revenue are present.</li>
            <li>Table values reconcile with your MIS.</li>
            <li>No personal identifiable data is included.</li>
          </ul>
        </Box>
        <Box>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '1rem',
              lineHeight: '1.25rem',
              color: '#162936',
              marginBottom: '0.75rem',
            }}
          >
            Security & Privacy Notice:
          </Typography>
          <ul
            style={{
              paddingLeft: '2rem',
              margin: 0,
              fontSize: '0.875rem',
              lineHeight: '1.25rem',
              fontWeight: 500,
              color: '#6C6C6C',
            }}
          >
            <li>Access is read-only and restricted to the provided tables.</li>
            <li>Your data is encrypted during transfer and only used for underwriting.</li>
            <li>You can revoke access at any time after the evaluation.</li>
          </ul>
        </Box>
      </Box>
    </Box>
  );
};

export default MySQLDetails;
